export enum ROLES {
  VIEWER = "VIEWER",
  OPERATOR = "OPERATOR",
  ADMIN = "ADMIN",
  USER = "USER",
  USER_APP = "USER_APP",
  ANY = "ANY"
}

export type User = {
  email: string;
  full_name: string;
  birthdate: string; // formato 'YYYY-MM-DD'
  cpf: string;
  phone: string;
  car_plate: string;
  car_brand: string;
  car_model: string;
  role: ROLES;
  station: string;
  status: string;
  createdAt: string; // formato ISO date-time
  updatedAt: string; // formato ISO date-time
};

export type UserLogin = {
  role: ROLES;
  full_name: string;
  station: string;
  token: string;
  refresh_token: string;
}

export type RefreshResponse = {
  access_token: string;
  refresh_token: string;
}

export interface Authority {
  authority: string;
}

export interface Collaborator {
  id: string;
  id_user: string;
  email: string;
  password: string;
  full_name: string;
  birthdate: string | null;
  cpf: string;
  phone: string;
  car_plate: string;
  car_brand: string;
  car_model: string;
  role: string;
  station: string;
  status: string;
  deviceTokens: string | null;
  createdAt: string;
  updatedAt: string;
  enabled: boolean;
  authorities: Authority[];
  username: string;
  accountNonLocked: boolean;
  credentialsNonExpired: boolean;
  accountNonExpired: boolean;
}